import Seo from "@/components/Seo";
import { HeroN, SoFunktioniertN, DasMachtRobbieN, BrancheN, KundenHerfordN, PreiseN, AbschlussN } from "@/components/StartseiteN";
import { ScrollNav } from "@/components/ScrollNav";
import { StickyTestCta } from "@/components/StickyTestCta";
import { Faq } from "@/components/Faq";
import { FAQ } from "@/data/faq";
import { graph, organization, person, website, webPage, faqPage } from "@/seo/schema";

/* Startseite – Punkt N (ruhiges Redesign, Thomas): 6 ruhige Abschnitte.
   1 Hero → 2 So funktioniert's → 3 Das macht Robbie für dich → 4 Für deine Branche
   → 5 Kunden aus Herford → 6 Preise + FAQ + Abschluss.
   Regeln: Gelb nur für Haupt-Button + ein Wort im Hero, dünne/keine Rahmen, Satz-Schreibweise,
   viel Luft, nur EIN Video (Hero-Loop + Lightbox = derselbe Film). */
const HOME_FAQ = [FAQ[0], FAQ[2], FAQ[3], FAQ[4], FAQ[5], FAQ[7]];

const Home = () => {
  return (
  <>
    <Seo
      title="DIMEDIAL – Robbie, dein digitaler Mitarbeiter für Sichtbarkeit"
      description="Robbie ist dein digitaler Mitarbeiter für Sichtbarkeit – per WhatsApp. Foto schicken, freigeben: Beitrag, Google-Meldung, Bildschirm und Website sind aktuell. Für Gastronomie, Handel und Vereine. Ab 59 € netto/Monat, 30 Tage kostenlos testen."
      path="/"
      jsonLd={graph(website(), organization(), person(), webPage("/", "DIMEDIAL – Robbie, dein digitaler Mitarbeiter für Sichtbarkeit", "Robbie ist dein digitaler Mitarbeiter für Sichtbarkeit – per WhatsApp. Foto schicken, freigeben: Beitrag, Google-Meldung, Bildschirm und Website sind aktuell. Für Gastronomie, Handel und Vereine."), faqPage(HOME_FAQ))}
    />
    <HeroN />
    <SoFunktioniertN />
    <DasMachtRobbieN />
    <BrancheN />
    <KundenHerfordN />
    <PreiseN />
    <Faq items={HOME_FAQ} initial={5} calm title="Häufige Fragen" heading={["Fragen, die oft kommen –", "einfach erklärt."]} />
    <AbschlussN />
    <ScrollNav />
    <StickyTestCta />
  </>
  );
};

export default Home;
